var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"linkified",rawName:"v-linkified:options",value:(_vm.linkifiedOptions),expression:"linkifiedOptions",arg:"options"}],staticClass:"sms-message",domProps:{"innerHTML":_vm._s(_vm.cleanMessage)}})
}
var staticRenderFns = []

export { render, staticRenderFns }